import { Component, Input } from '@angular/core';
import { Evento } from '../../../models/evento.model';

@Component({
  selector: 'c-simple-event',
  templateUrl: './simple-event.component.html',
  styleUrl: './simple-event.component.css',
  standalone: true,
})
export class SimpleEventComponent {
  @Input() event!: Evento;
  @Input() index: number = 0;

  px = 0;
  timeReference = 'a.m.';
  actualTime = '0';
  ngOnInit() {
    const eventDate = new Date(this.event.inicio ?? 0);
    this.px = (eventDate.getHours() * 60 + eventDate.getMinutes()) / 2;
    this.timeReference = eventDate.getHours() >= 12 ? 'p.m.' : 'a.m.';
    this.actualTime = eventDate.getHours() + ':' + eventDate.getMinutes();
  }
}
